import React from "react";

const ConnectifyIcon = ({size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4_29)">
        <rect x="4" width="112" height="106.728" rx="31" fill="#620C45" />
        <g filter="url(#filter1_d_4_29)">
          <rect
            x="75.0862"
            y="20.4722"
            width="19.9138"
            height="21.8534"
            rx="5"
            stroke="white"
            strokeWidth="4"
            shapeRendering="crispEdges"
          />
        </g>
        <rect
          x="26"
          y="65.128"
          width="19.9138"
          height="21.8534"
          rx="5"
          stroke="white"
          strokeWidth="4"
        />
        <path
          d="M46.6552 76.6423H49.2111C56.0485 76.6423 61.504 70.9379 61.1992 64.1073L60.3282 44.5903C60.0648 38.687 64.1382 33.4705 69.9293 32.2951L74.3448 31.3989"
          stroke="white"
          strokeWidth="4"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4_29"
          x="0"
          y="0"
          width="120"
          height="114.728"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4_29"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4_29"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_4_29"
          x="69.0862"
          y="18.4722"
          width="31.9138"
          height="33.8534"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4_29"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4_29"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ConnectifyIcon;














